export default __webpack_public_path__ + "static/media/底.c06a70fa.png";